<template>
    <div>
        <div class="form-group ">
            <label> {{ __("forms.SatisfactionSurvey.maxEvaluationScale") }}</label>
            <input class="form-control" type="number" v-model="max_evaluation_value">
        </div>
        <div class="form-group ">
            <label> {{ __("forms.SatisfactionSurvey.courseSector") }}</label>
            <div class="" v-for="(group,key) in sectors.course">
                <div class="row">
                    <div class="col-1">
                        <button class="btn btn--blue px-2" @click="questionsGroup('course',key,group.label)">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="btn btn--danger px-2" @click="deleteGroup(key,'course')">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                    <div class="col-2">
                      {{ __("forms.SettingSurvey." + key) }}
                    </div>
                    <div class="col-4">
                        <input type="text" class="form-control" @change="updateGroup(key,group,'course')" v-model="group.label">
                    </div>
                    <div class="col-1">
                        <input type="number" class="form-control" @change="updateGroup(key,group,'course')" v-model="group.sort">
                    </div>
                    <div class="col-2">
                        <label>{{ __("forms.SatisfactionSurvey.enable_comment") }}</label>
                        <input type="checkbox" @change="updateGroup(key,group,'course')" v-model="group.enable_comment">
                    </div>
                    <div class="col-2">
                        <span>{{ __("forms.SatisfactionSurvey.comment") }}</span>
                        <input type="text" class="form-control" @change="updateGroup(key,group,'course')" v-model="group.comments">
                    </div>
                </div>
            </div>
        </div>
      <div class="form-group ">
        <label> {{ __("forms.SatisfactionSurvey.trainersSector") }}</label>
        <div class="" v-for="(group,key) in sectors.trainers">
          <div class="row">
            <div class="col-1">
              <button class="btn btn--danger" @click="deleteGroup(key,'trainers')">
                <i class="fas fa-trash"></i>
              </button>
              <button class="btn btn--blue" @click="questionsGroup('trainers',key,group.label)">
                <i class="fas fa-edit"></i>
              </button>
            </div>

            <div class="col-1">
              {{key}}
            </div>
            <div class="col-4">

              <input type="text" class="form-control" @change="updateGroup(key,group,'trainers')" v-model="group.label">
            </div>
            <div class="col-2">
              <input type="number" class="form-control" @change="updateGroup(key,group,'trainers')" v-model="group.sort">
            </div>

            <div class="col-1">
              <label>{{ __("forms.SatisfactionSurvey.enable_comment") }}</label>
              <input type="checkbox" @change="updateGroup(key,group,'trainers')" v-model="group.enable_comment">
            </div>
            <div class="col-3">
              <label>{{ __("forms.SatisfactionSurvey.comment") }}</label>
              <input type="text" class="form-control" @change="updateGroup(key,group,'trainers')" v-model="group.comments">
            </div>
          </div>
        </div>
      </div>
      <div class="form-group ">
        <label> {{ __("forms.SatisfactionSurvey.tutorSector") }}</label>
        <div class="" v-for="(group,key) in sectors.tutors">
          <div class="row">
            <div class="col-1">
              <button class="btn btn--danger" @click="deleteGroup(key,'tutors')">
                <i class="fas fa-trash"></i>
              </button>
              <button class="btn btn--blue" @click="questionsGroup('tutors','tutors',key,group.label)">
                <i class="fas fa-edit"></i>
              </button>
            </div>

            <div class="col-1">
              <label>{{  __("forms.SatisfactionSurvey.key")  }}</label>
              {{key}}

            </div>
            <div class="col-4">
              <label>Label</label>
              <input type="text" class="form-control" @change="updateGroup(key,group,'tutors')" v-model="group.label">
            </div>
            <div class="col-2">
              <label>Label</label>
              <input type="number" class="form-control" @change="updateGroup(key,group,'tutors')" v-model="group.sort">
            </div>

            <div class="col-1">
              <label>{{ __("forms.SatisfactionSurvey.enable_comment") }}</label>
              <input type="checkbox" @change="updateGroup(key,group,'tutors')" v-model="group.enable_comment">
            </div>
            <div class="col-3">
              <label>{{ __("forms.SatisfactionSurvey.comment") }}</label>
              <input type="text" class="form-control" @change="updateGroup(key,group,'tutors')" v-model="group.comments">
            </div>
          </div>
        </div>
      </div>
      <div class="form-group ">
        <label> {{ __("forms.SatisfactionSurvey.TrainingAgencySector") }}</label>
        <div class="" v-for="(group,key) in sectors.training_agency">
          <div class="row">
            <div class="col-1">
              <button class="btn btn--danger" @click="deleteGroup(key,'training_agency')">
                <i class="fas fa-trash"></i>
              </button>
              <button class="btn btn--blue" @click="questionsGroup('training_agency',key,group.label)">
                <i class="fas fa-edit"></i>
              </button>
            </div>

            <div class="col-1">
              <label>{{  __("forms.SatisfactionSurvey.key")  }}</label>
              {{key}}

            </div>
            <div class="col-4">
              <label>Label</label>
              <input type="text" class="form-control" @change="updateGroup(key,group,'training_agency')" v-model="group.label">
            </div>
            <div class="col-2">
              <label>Label</label>
              <input type="number" class="form-control" @change="updateGroup(key,group,'training_agency')" v-model="group.sort">
            </div>

            <div class="col-1">
              <label>{{ __("forms.SatisfactionSurvey.enable_comment") }}</label>
              <input type="checkbox" @change="updateGroup(key,group,'training_agency')" v-model="group.enable_comment">
            </div>
            <div class="col-3">
              <label>{{ __("forms.SatisfactionSurvey.comment") }}</label>
              <input type="text" class="form-control" @change="updateGroup(key,group,'training_agency')" v-model="group.comments">
            </div>
          </div>
        </div>
      </div>
          <hr>
          <div class="row form-group">
            <div class="col-2">
              <label>{{ __("forms.SatisfactionSurvey.selectSection") }}</label>
              <select class="form-control" v-model="sectionNewGroup">
                <option value="course">{{ __("forms.SatisfactionSurvey.course") }} </option>
                <option value="trainers"> {{ __("forms.SatisfactionSurvey.trainers") }}</option>
                <option value="tutors"> {{ __("forms.SatisfactionSurvey.tutors") }}</option>
                <option value="training_agency">{{ __("forms.SatisfactionSurvey.training_agency") }}</option>
              </select>
            </div>
            <div class="col-2">
              <label>{{  __("forms.SatisfactionSurvey.key")  }}</label>
              <input type="text" v-model="newKeyGroup" class="form-control">
            </div>
            <div class="col-3">
              <label>Label</label>
              <input type="text" v-model="newLabelGroup" class="form-control">
            </div>
            <div class="col-3">
              <label>{{ __("forms.SatisfactionSurvey.sorting") }}</label>
              <input type="number" v-model="newSorting" class="form-control">
            </div>
            <div class="col-1">
              <label>{{ __("forms.SatisfactionSurvey.enable_comment") }}</label>
              <input type="checkbox" v-model="newEnableComment" class="">
            </div>
            <div class="col-3">
              <label>{{ __("forms.SatisfactionSurvey.comment") }}</label>
              <input type="text" v-model="newCommentGroup" class="form-control">
            </div>
            <div class="col-3" style="margin-top:10px">
              <button class="btn btn--save" @click="addGroup()">
                <i class="fas fa-plus"> {{ __("forms.SatisfactionSurvey.addGropu") }}</i>
              </button>
            </div>
          </div>
    </div>
</template>

<script>
export default {
    mounted() {
      this.getSatisfactionSurvey();
    },
    data () {
        return {
            max_evaluation_value: 0,
            sectors : [],
            newKeyGroup : "",
            newLabelGroup : "",
            newCommentGroup : "",
            newSorting : 0,
            newEnableComment : 1,
            sectionNewGroup : "course",
        }
    },
    methods: {
        confirm(){
            Vue.$toast.open({
              message: 'Save Complete!',
              type: 'success',
              position: 'top-right'
            });  
        },
        questionsGroup(sectorIndex,index,groupQuestion){
          app.__vue__.$refs.satisfactionSurveyQuestion.toggle(sectorIndex,index,groupQuestion);
        },

        updateGroup(keyGroup,group,sectorIndex){
          axios.put(("/save-satisfaction-survey-settings-group/"+this.satisfaction_survey),  {
                sectorIndex           : sectorIndex,
                keyGroup              : keyGroup,
                group                 : group,
            }).then((response) => {
              this.getSatisfactionSurvey();
              this.confirm();
          }).catch(function(error){
            alert(error);
          });
        },
        //satisfaction-survey-settings-delete-group/
        deleteGroup(keyGroup,sectorIndex){
            //ajax post, create new group on template
            axios.delete(("/satisfaction-survey-settings-delete-group/"+this.satisfaction_survey),  {
                params : {
                  sectorIndex : sectorIndex,
                  keyGroup    : keyGroup,
                },
            }).then((response) => {
                this.getSatisfactionSurvey();
                this.confirm();
            }).catch(function(error){
              alert(error);
            });
        },
        addGroup(){
            //ajax post, create new group on template
            axios.post(("/satisfaction-survey-settings-new-group/"+this.satisfaction_survey),  {
                newGroup : {
                    keyGroup            : this.newKeyGroup,
                    newEnableComment    : this.newEnableComment,
                    newSorting          : this.newSorting,
                    newLabelGroup       : this.newLabelGroup,
                    newCommentGroup     : this.newCommentGroup,
                },
                sectorIndex : this.sectionNewGroup,
            }).then((response) => {
                this.getSatisfactionSurvey();
                this.confirm();
            }).catch(function(error){
              alert(error);
            });
            this.newKeyGroup = "";
            this.newLabelGroup = "";
            this.newCommentGroup = "";
            this.newSorting = 0;
            this.newEnableComment = 1;
        },
        getSatisfactionSurvey () {
          axios.get(("/get-satisfaction-survey-settings/"+this.satisfaction_survey), {params: {

            }}).then((response) => {
              this.max_evaluation_value = response.data.max_evaluation_value;
              this.sectors = response.data.sectors;

          }).catch(function(error){
            alert(error);
          });
        }
    },
    props: {
        satisfaction_survey : {
            type:Number,
            required: true
        },
    }
}
</script>

<style>
</style>
